import b1zSample from "./samples/Roland TR 909/Bass Drum/bt0a0da.wav";
import b1xSample from "./samples/Roland TR 909/Snare/st0t0s0.wav";
import b1cSample from "./samples/Roland TR 909/Closed Hihat/hhcd0.wav";
import b1aSample from "./samples/Roland TR 909/Hand Clap/handclp1.wav";
import b1sSample from "./samples/Roland TR 909/Low Tom/lt0d0.wav";
import b1dSample from "./samples/Roland TR 909/Open Hihat/hhod0.wav";
import b1qSample from "./samples/Roland TR 909/Crash/cshd0.wav";
import b1wSample from "./samples/Roland TR 909/Mid Tom/mt0d0.wav";
import b1eSample from "./samples/Roland TR 909/Ride/rided0.wav";

const banks = {
  b1: {
    q: b1qSample,
    w: b1wSample,
    e: b1eSample,
    a: b1aSample,
    s: b1sSample,
    d: b1dSample,
    z: b1zSample,
    x: b1xSample,
    c: b1cSample,
  },
  b2: {
    q: "",
    w: "",
    e: "",
    a: "",
    s: "",
    d: "",
    z: "",
    x: "",
    c: "",
  },
  b3: {
    q: "",
    w: "",
    e: "",
    a: "",
    s: "",
    d: "",
    z: "",
    x: "",
    c: "",
  },
  b4: {
    q: "",
    w: "",
    e: "",
    a: "",
    s: "",
    d: "",
    z: "",
    x: "",
    c: "",
  },
};

export default banks;
